import {httpRequest} from "../../..//utils/HttpRequest";
import {IPage} from "../../../types/FmsTypes";
import {
    IServiceItemsDetail,
    IServiceItemsDisable, IServiceItemShopPriceDetail,
    IServiceItemsInsert,
    IServiceItemsSearch, IServiceItemsShopPriceParams,
    IServiceItemsUpdata
} from "./serviceItemsTypes"

class ServiceItemsService {
    async page(params: IServiceItemsSearch) {
        const apiUrl = "/md/si/page"
        return await httpRequest.post<IPage<IServiceItemsDetail>>(apiUrl, params)
    }

    async insert(params: IServiceItemsInsert) {
        const apiUrl = "/md/si/insert"
        return await httpRequest.post<boolean>(apiUrl, params)
    }

    async update(params: IServiceItemsUpdata) {
        const apiUrl = "/md/si/update"
        return await httpRequest.post<boolean>(apiUrl, params)
    }

    async disable(params: IServiceItemsDisable) {
        const apiUrl = "/md/si/disable"
        return await httpRequest.post<boolean>(apiUrl, params)
    }

    async shopInsertOrUpDate(params: IServiceItemsShopPriceParams) {
        const apiUrl = "/md/shopServiceItem/insertOrUpdate"
        return await httpRequest.post<boolean>(apiUrl, params)
    }

    async shopOne(shopCode: string, itemCode: string) {
        const apiUrl = "/md/shopServiceItem/one"
        return await httpRequest.post<IServiceItemShopPriceDetail>(apiUrl, {code: shopCode, serviceItemCode: itemCode})
    }


}

const serviceItemsService = new ServiceItemsService()
export {
    serviceItemsService
}
